import {
    StyleSheet
} from "react-native";
import type {
    PaginationPageSizeDynamicStyleType
} from "./type";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 0
    }
});

export const useStyles = ({
    spaces
}: PaginationPageSizeDynamicStyleType) => {
    return {
        container: {
            gap: spaces.spacingSm
        }
    };
};
export default stylesheet;
